module.exports = __webpack_public_path__ + "static/media/Final-Day-mobile.8d3567f8.webp";